import { extendTailwindMerge } from 'tailwind-merge';

import { sizing, colors, fontSize } from '../tailwind';

export const twMergeConfig = {
  extend: {
    theme: {
      spacing: Object.keys(sizing),
    },
    classGroups: {
      'font-size': [{ text: Object.keys(fontSize) }],
      'text-color': [{ text: Object.keys(colors) }],
    },
  },
};

export const twMerge = extendTailwindMerge(twMergeConfig);
